import Api from '.';
import { buildQueryString } from 'app/utils/index';

/**
 *
 * Retrieve all professionals.
 */
export function getProfessionals() {
  return Api.get('/professional');
}

export function getOnlyProfessionals() {
  return Api.get('/professional/listonlyprofessionals');
}

/**
 *
 * Retrieve all professionals by profession.
 * @param {number} professionId
 * @return {array} professionals by profession
 */
export function getProfessionalsByProfession(professionId) {
  return Api.get(`/professional/profession/${professionId}`);
}

/**
 *
 * Retrieve all professionals from the same business partner
 * @param {number} businessPartnerId
 * @param {array} professionals by business partner
 */
export function getProfessionalsByBusinessPartner(businessPartnerId) {
  return Api.get(`/professional/cooperative/${businessPartnerId}`);
}

/**
 * Retrieve professionals by params.
 */
export function lazySearch({ search, page, perPage, CBOCodes, professionId }) {
  const query = buildQueryString({ search, page, perPage, CBOCodes, professionId });

  return Api.get(`/professional/lazy-search?` + query);
}

/**
 * Retrieve professionals by params.
 */
export function lazyList({ search, page, perPage, CBOCode, professionId, responsibleType }) {
  const query = buildQueryString({ search, page, perPage, CBOCode, professionId, responsibleType });

  return Api.get(`/professional/lazy?` + query);
}

export function lazyLoad({ search, page, perPage, CBOCode, professionId, responsibleType }) {
  const query = buildQueryString({ search, page, perPage, CBOCode, professionId, responsibleType });

  return Api.get(`/professional/lazy-load?` + query);
}

export function getProfessionalsByResponsibleType(responsibleType) {
  return Api.get(`/professional/dropdown/responsibleType/${responsibleType}`);
}
/**
 *
 * Retrieve professionals by lazyLoad.
 * @param {object} search, page, perPage
 * @param {number} professionalId
 * @return {array} professionals by profession
 */
export function lazyGetProfessionals({ search, page, perPage }, professionId) {
  return Api.get(
    `/professional/profession/${professionId}/lazy?search=${search}&page=${page}&perPage=${perPage}`
  );
}

/**
 *
 * Retrieve professional by ID.
 */
export function fetchProfesssionalById(id) {
  return Api.get(`/professional/${id}`);
}

/**
 *
 * Retrieve professional by ID.
 */
export function getProfesssional(id) {
  return Api.get(`/professional/id/${id}`);
}

/**
 *
 * Create professional.
 */
export function createProfessional(professional) {
  return Api.post(`/professional?profession=${professional.professionId}`, professional);
}

/**
 *
 * Update professional.
 */
export function updateProfessional(id, professional) {
  return Api.put(`/professional/${id}`, professional);
}

/**
 *
 * Deactivate an existing professional
 */
export function deactivateProfessional(id) {
  return Api.put(`/professional/${id}/deactivate`);
}

/**
 *
 * Reactivate an existing professional
 */
export function reactivateProfessional(id) {
  return Api.put(`/professional/${id}/reactivate`);
}

/**
 *
 * Delete professional.
 */
export function deleteProfessional(id) {
  return Api.delete(`/professional/${id}`);
}

/**
 *
 * get professional signature.
 */
export function getSignature(id) {
  return Api.get(`/professional/signature/${id}`);
}
